export default __webpack_public_path__ + "17c88f906cb7f46c13ed3417b4367c4e.png";